<template>
    <div style="padding:14px 0px 0px">
        <label for="file-upload" class="custom-file-upload">
        Attach files
      </label>
        <input id="file-upload" type="file" @change="uploadImage" />
        <span>{{fileName}}</span>
        <span class="text text-danger error-label" v-if="errors && errors.length">{{ errors[0] }}</span>
        <div id="download_285624" download="" v-for="(uploadedFile,index) in uploadedFiles">
            <p class="download_box" >
                <a :download="getFileName(uploadedFile)" href="#">
                    {{getFileName(uploadedFile)}}</a>
                <i class="close fa fa-trash" @click="removeFile(index)" :data-index="index"></i>
            </p>
        </div>
        <input type="hidden" :id="id" :name="name" :value="uploadedFilesJsoned">

        <div v-for="(answerAttachment,index) in answerAttachments" style='width: 112px; float: left;height: 112px;margin-left: 5px;margin-right: 5px;'>
        <i @click="deleteImagePermanentConfirm(index,answerAttachment.attachment_id)" class='fa fa-close' style='display: block;position: relative;top: 5px;font-size: 16px;color: #000000;text-align: right;cursor: pointer'></i>
        <img @click="magnifierImage"  :data-original="answerAttachment.path" :src="answerAttachment.thumbnail_file" style='cursor: zoom-in;width: 112px; float: left;height: 112px;
        margin-left: 5px;margin-right: 5px;margin-top: -15px' class='thumbnail'>
       </div>
        <confirmation-popup
            title="Warning"
            message="Are you sure you want to delete this File?"
            :id="confirmationDialogId" @on-confirm="deleteImagePermanent"></confirmation-popup>
<!--        <div class="modal fade" id="show_answer_image_full" tabindex="-1" role="dialog">-->
<!--            <div class="modal-dialog" role="document">-->
<!--                <div class="modal-content">-->
<!--                    <div class="modal-header" style="min-height: 45px;">-->
<!--                        <h5 class="modal-title" style="float: left;">Image View</h5>-->
<!--                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
<!--                            <span aria-hidden="true">&times;</span>-->
<!--                        </button>-->
<!--                    </div>-->
<!--                    <div class="modal-body" style="padding: 10px">-->
<!--                        <img src="" id="image" style="width: 100%">-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
import axios from 'axios';
import {deleteAttachment} from "@/modules/Forms/api";
import {EventBus} from "@/events/event-bus";

export default {
    name: 'ImageUploader',
    props:{
        question:'',
    },
    data(){
        return {
            uploadedFiles:[],
            name:`uploaded_image_for_question_${this.question.update_booking_question_id}[]`,
            id:`uploaded_image_for_question_${this.question.update_booking_question_id}`,
            confirmationDialogId:`delete_attachment_in_forms_question_${this.question.update_booking_question_id}`,
            errors:[],
            fileName: "No files selected"
        }
    },
    methods: {
        uploadImage(event) {
            this.errors = [];
            const files = event.target.files;
            if (!files.length) return;

            const file = files[0];
            const formData = new FormData();
            formData.append('file', file);
            this.fileName = file ? file.name : "No files selected";

            let vm = this;

            $.ajax({
                url: "/default/upload-to-cloud",
                async: true,
                cache: false,
                type: 'POST',
                contentType: false,
                enctype: 'multipart/form-data',
                processData: false,
                data: formData,
                success: function(response) {
                    let imageUploadedPath = response;
                    if (imageUploadedPath){
                        vm.uploadedFiles.push(imageUploadedPath);
                    }

                },error: function(xhr, status, error) {
                    reject(error); // Reject the promise with the error message
                }
            });
            // Call your backend endpoint that handles the image upload to S3
            // axios.post('/default/upload-to-cloud', formData, {
            //     headers: {
            //         'Content-Type': 'multipart/form-data'
            //     },
            // })
            //     .then((response) => {
            //         let imageUploadedPath = response.data;
            //         if (imageUploadedPath){
            //             this.uploadedFiles.push(imageUploadedPath);
            //         }
            //     })
            //     .catch((error) => {
            //         console.error('Error uploading image:', error);
            //     });
        },
        getFileName(filePath) {
            // Extract the file name from the URL
            return filePath.split('/').pop();
        },
        removeFile(index) {
            // Remove the file at the given index
            this.uploadedFiles.splice(index, 1);
        },
        magnifierImage() {
            let image = $(event.target);
            var imageSrc = image.data('original');
            var modal = $('#show_answer_image_full');
            var modalImage = modal.find('#image');
            modalImage.attr('src', imageSrc);
            modal.modal('show');

        },
        deleteImagePermanentConfirm(index,attachmentId){
            this.imageToBeDeltedIndex = index;
            this.imageAttachmentIdToBeDeleted = attachmentId
            $(`#${this.confirmationDialogId}`).modal('show')
        },
        deleteImagePermanent(){
            deleteAttachment(this.imageAttachmentIdToBeDeleted).then(response => {
                this.question.answer_attachment.splice(this.imageToBeDeltedIndex,1)
            })
        },
        addEventListeners() {
            var vm = this;
            EventBus.$on('onFormsAndCheckListsValidation', async (verify)=> {
                let validated = false;
                if (vm.question.require_answer_photo){
                    if ((vm.uploadedFiles && vm.uploadedFiles.length > 0) || ( typeof (vm.answerAttachments) != 'undefined' && vm.answerAttachments.length > 0)) {
                        validated = true
                    }
                    else {
                        this.errors.push('You should upload photo for this answer')
                    }
                }
                else {
                    validated = true
                }
                verify(validated)
            })
        },
    },
    mounted() {
        this.addEventListeners()
    },
    computed:{
        uploadedFilesJsoned(){
            let result = {};
            let key = `question_${this.question.update_booking_question_id}`;
            result[key] = this.uploadedFiles;
            return JSON.stringify(result)
        },
        answerAttachments(){
            if (this.question.answer_attachment){
                return this.question.answer_attachment
            }
        }
    }
};
</script>

<style scoped>
.custom-file-upload {
  cursor: pointer;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  display: inline-block;
  font-weight: 400;
}
input#file-upload   {
  display: none !important;
}

</style>
